import { render, staticRenderFns } from "./hotel-faq.vue?vue&type=template&id=358b328c&"
import script from "./hotel-faq.vue?vue&type=script&lang=ts&"
export * from "./hotel-faq.vue?vue&type=script&lang=ts&"
import style0 from "./hotel-faq.vue?vue&type=style&index=0&id=358b328c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports